
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-white text-[#0B1D2E] border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/3e17d0c88707d4fbad78ae9da78cb4a3/0423293d489cd1cecbfc0b07e5d5744a.jpeg" 
                alt="Hera Minerals Logo" 
                className="h-10 w-auto"
              />
            </div>
            <p className="text-sm mb-4 text-gray-600" style={{ fontFamily: '"Open Sans", sans-serif' }}>
              A 100% Black youth- and woman-owned mining company, subsidiary of Segra Group, 
              committed to sustainable practices and community development.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center bg-[#2DD4BF]/20 rounded-full hover:bg-[#2DD4BF] hover:text-white transition-colors duration-200 cursor-pointer">
                <i className="ri-linkedin-fill text-sm text-[#2DD4BF] hover:text-white"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center bg-[#2DD4BF]/20 rounded-full hover:bg-[#2DD4BF] hover:text-white transition-colors duration-200 cursor-pointer">
                <i className="ri-twitter-fill text-sm text-[#2DD4BF] hover:text-white"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center bg-[#2DD4BF]/20 rounded-full hover:bg-[#2DD4BF] hover:text-white transition-colors duration-200 cursor-pointer">
                <i className="ri-facebook-fill text-sm text-[#2DD4BF] hover:text-white"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-[#2DD4BF] mb-4" style={{ fontFamily: '"Montserrat", sans-serif' }}>
              Quick Links
            </h4>
            <ul className="space-y-2" style={{ fontFamily: '"Open Sans", sans-serif' }}>
              <li><Link to="/about" className="text-sm text-gray-600 hover:text-[#2DD4BF] transition-colors duration-200 cursor-pointer">About Us</Link></li>
              <li><Link to="/operations" className="text-sm text-gray-600 hover:text-[#2DD4BF] transition-colors duration-200 cursor-pointer">Operations</Link></li>
              <li><Link to="/sustainability" className="text-sm text-gray-600 hover:text-[#2DD4BF] transition-colors duration-200 cursor-pointer">Sustainability</Link></li>
              <li><Link to="/contact" className="text-sm text-gray-600 hover:text-[#2DD4BF] transition-colors duration-200 cursor-pointer">Contact</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold text-[#2DD4BF] mb-4" style={{ fontFamily: '"Montserrat", sans-serif' }}>
              Contact Info
            </h4>
            <div className="space-y-3" style={{ fontFamily: '"Open Sans", sans-serif' }}>
              <div className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-[#2DD4BF] mt-1"></i>
                <p className="text-sm text-gray-600">774 Block L, Soshanguve, Gauteng, South Africa</p>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line text-[#2DD4BF]"></i>
                <p className="text-sm text-gray-600">+27 (0) 11 123-4567</p>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line text-[#2DD4BF]"></i>
                <p className="text-sm text-gray-600">info@heraminerals.co.za</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-600" style={{ fontFamily: '"Open Sans", sans-serif' }}>
            © 2025 Hera Minerals (Pty) Ltd. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-sm text-[#2DD4BF] hover:text-[#14B8A6] transition-colors duration-200 mt-2 md:mt-0 cursor-pointer"
            style={{ fontFamily: '"Open Sans", sans-serif' }}
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}